
import { Vue, Component } from 'vue-property-decorator';
import CustomButton from '~/components/Buttons/CustomButton.vue';

@Component({
  components: { CustomButton },
})
export default class PortalIntro extends Vue {
  show = true;
}
